import React from 'react'
import { Table, Skeleton, Row, Col } from 'antd'
import BillingTool from '../../../../Bookings/components/Examination Components/BillingTool'

/**
 * A wrapper for BillingTool that adds skeleton loading
 */
const BillingToolWrapper = (props) => {
  const { loading, ...restProps } = props

  // Columns for the skeleton table
  const columns = [
    { title: 'Type', dataIndex: 'type', width: '10%' },
    { title: 'Code', dataIndex: 'code', width: '10%' },
    { title: 'Name', dataIndex: 'name' },
    { title: 'Qty', dataIndex: 'qty', width: '5%' },
    { title: 'ICD10', dataIndex: 'icd10', width: '10%' },
    { title: 'Pack Size', dataIndex: 'packSize', width: '5%' },
    { title: 'Total', dataIndex: 'total', width: '7%' },
    { title: 'Medical Aid', dataIndex: 'medicalAid', width: '7%' },
    { title: 'Patient', dataIndex: 'patient', width: '7%' },
    { title: 'Actions', dataIndex: 'actions', width: '5%' }
  ]

  // Create skeleton data for the table
  const generateSkeletonRows = () => {
    return Array(3)
      .fill()
      .map((_, index) => ({
        key: `skeleton-${index}`,
        type: <Skeleton.Input style={{ width: '100%' }} active size='small' />,
        code: <Skeleton.Input style={{ width: '100%' }} active size='small' />,
        name: <Skeleton.Input style={{ width: '100%' }} active size='small' />,
        qty: <Skeleton.Input style={{ width: '100%' }} active size='small' />,
        icd10: <Skeleton.Input style={{ width: '100%' }} active size='small' />,
        packSize: <Skeleton.Input style={{ width: '100%' }} active size='small' />,
        total: <Skeleton.Input style={{ width: '100%' }} active size='small' />,
        medicalAid: <Skeleton.Input style={{ width: '100%' }} active size='small' />,
        patient: <Skeleton.Input style={{ width: '100%' }} active size='small' />,
        actions: <Skeleton.Button style={{ width: 24 }} active size='small' />
      }))
  }

  // Render the skeleton table view
  if (loading) {
    return (
      <>
        <Table columns={columns} dataSource={generateSkeletonRows()} pagination={false} rowKey='key' />

        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ width: 300 }}>
            <Row gutter={8}>
              <Col span={12} style={{ textAlign: 'right' }}>
                <strong>Totals</strong>
              </Col>
              <Col span={4}>
                <Skeleton.Input style={{ width: '100%' }} active size='small' />
              </Col>
              <Col span={4}>
                <Skeleton.Input style={{ width: '100%' }} active size='small' />
              </Col>
              <Col span={4}>
                <Skeleton.Input style={{ width: '100%' }} active size='small' />
              </Col>
            </Row>
          </div>
        </div>
      </>
    )
  }

  return <BillingTool {...restProps} billingRecordsLoading={false} />
}

export default BillingToolWrapper
